import _fieldDirectiveFinder from "./_fieldDirectiveFinder";
import {fromPairs} from "lodash/array";

export default ({typeDefs, resolvers}) => {
    let noGuard = []
    typeDefs = _fieldDirectiveFinder(typeDefs)((directive, field, model) => {
        if (directive.name.value === 'unguard') {
            noGuard.push(model.name.value + (field ? `.${field.name.value}` : ''));
            return true;
        }
    })
    noGuard = noGuard.map(g => {
        g = g.split('.');
        return g.length === 1 ? g[0] : (g[0] === 'Mutation' ? g[1] : false)
    }).filter(v => v)

    return {
        typeDefs,
        resolvers: {
            ...resolvers,
            Mutation: fromPairs(Object.keys(resolvers.Mutation).map(m => [
                m,
                noGuard.includes(m) ? resolvers.Mutation[m] : (p, a, c, i) => {
                    if (!c.user?.scopes.includes('is_admin')) {
                        throw new Error('Access denied')
                    }
                    return resolvers.Mutation[m](p, a, c, i)
                }]))
        }
    };
}
